var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconmobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.8,
    height: 18.64,
    viewBox: "0 0 23.8 18.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-menu",
    "data-name": "Icon ionic-ios-menu",
    transform: "translate(-2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M30.785,12.243H15.559A1.062,1.062,0,0,1,14.5,11.184h0a1.062,1.062,0,0,1,1.059-1.059H30.785a1.062,1.062,0,0,1,1.059,1.059h0A1.062,1.062,0,0,1,30.785,12.243Z",
    transform: "translate(-6.043 -12.125)",
    fill: "#1c1b1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M29.241,18.993H7.559A1.062,1.062,0,0,1,6.5,17.934h0a1.062,1.062,0,0,1,1.059-1.059H29.241A1.062,1.062,0,0,1,30.3,17.934h0A1.062,1.062,0,0,1,29.241,18.993Z",
    transform: "translate(-4.5 -10.614)",
    fill: "#1c1b1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M30.785,25.743H15.559A1.062,1.062,0,0,1,14.5,24.684h0a1.062,1.062,0,0,1,1.059-1.059H30.785a1.062,1.062,0,0,1,1.059,1.059h0A1.062,1.062,0,0,1,30.785,25.743Z",
    transform: "translate(-6.043 -9.103)",
    fill: "#1c1b1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconmobile);
export default __webpack_public_path__ + "static/media/menu-iconmobile.888da32e1f19192f1faffaae353bbeeb.svg";
export { ForwardRef as ReactComponent };